import { get, post, del } from './API';
import toNumber from '../Utils/toNumber';

const serializeCoordinate = (coord) => (coord && {
  ...coord,
  latitude: toNumber(coord.latitude),
  longitude: toNumber(coord.longitude),
});

const serializeCalculatePriceParams = (params) => ({
  ...params,
  origin: serializeCoordinate(params.origin),
  destination: serializeCoordinate(params.destination),
  hours: toNumber(params.hours),
});

export default {
  // Vehicle Categories
  fetchVehicleCategories: async () => get('pricing/vehicle-categories'),
  createOrUpdateVehicleCategory: async (category) => post('pricing/vehicle-categories', category),
  deleteVehicleCategory: async (id) => del('pricing/vehicle-categories', { id }),
  uploadVehicleCategoryImage: async (categoryId, imageData, contentType) => post(
    'pricing/vehicle-categories',
    { categoryId, imageData, contentType },
    {},
    { action: 'upload-image' },
  ),
  removeVehicleCategoryImage: async (categoryId) => post(
    'pricing/vehicle-categories',
    { categoryId },
    {},
    { action: 'remove-image' },
  ),

  // Service Areas
  fetchServiceAreas: async () => get('pricing/service-areas'),
  fetchBaseLocations: async () => get('pricing/service-areas', { baseOnly: 'true' }),
  createOrUpdateServiceArea: async (serviceArea) => post('pricing/service-areas', serviceArea),
  deleteServiceArea: async (id) => del('pricing/service-areas', { id }),

  // Predefined Routes
  fetchPredefinedRoutes: async () => get('pricing/predefined-routes'),
  createOrUpdatePredefinedRoute: async (route) => post('pricing/predefined-routes', route),
  deletePredefinedRoute: async (id) => del('pricing/predefined-routes', { id }),

  // Calculate Price
  calculatePrice: async (params) => post('pricing/calculate', serializeCalculatePriceParams(params)),

  // Pricing Report
  fetchAvailableReportRoutes: async () => get('pricing/report'),
  generatePricingReport: async (params, config = {}) => post('pricing/report', params, config),

  // Operator Pricing Profiles
  fetchOperatorPricingProfile: async (operatorId) => (
    get(`operator-pricing-profiles/get?operator_id=${encodeURIComponent(operatorId)}`)
  ),
  saveOperatorPricingProfile: async (profile) => post('operator-pricing-profiles/upsert', profile),
  deleteOperatorPricingProfile: async (operatorId) => (
    del(`operator-pricing-profiles/delete?operator_id=${encodeURIComponent(operatorId)}`)
  ),

  // Operator Quotes
  getOperatorQuote: async (bookingId, operatorId) => post(
    'pricing/operator-quote',
    { booking_id: bookingId, operator_id: operatorId },
  ),
  getOperatorQuoteBulk: async (bookingId, operatorIds) => post(
    'pricing/operator-quote-bulk',
    { booking_id: bookingId, operator_ids: operatorIds },
  ),
  // No applyOperatorQuote — Apply is a pure UI action that fills the form's
  // operator_price + operator_currency, and the existing booking-save flow
  // persists them alongside any snapshot fields the form populated.
};
